import api from "./Api";

class ProdKitService {
  GetProdKit(payload) {
    return api.get("/v1/prodKit/" + payload).then((response) => {
      return response.data;
    });
  }

  PostProdKit(payload) {
    return api.post("/v1/prodKit/", payload).then((response) => {
      return response.data;
    });
  }

  PutProdKit(payload) {
    return api.put("/v1/prodKit/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteProdKit(payload) {
    return api.delete("/v1/prodKit/" + payload).then((response) => {
      return response.data;
    });
  }

  GetProdKitOData(payload) {
    return api.get("/OData/ProdKit" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new ProdKitService();
